export default __webpack_public_path__ + "static/media/1971.dea77634.png";